<!-- Start Page Title Area -->
<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <h2>Frequently Asked Questions</h2>
            <ul>
                <li><a routerLink="/">Home</a></li>
                <li>FAQ</li>
            </ul>
        </div>
    </div>
</div>
<!-- End Page Title Area -->

<!-- Start FAQ Area -->
<section class="faq-area ptb-110">
    <div class="container">
        <div class="section-title">
            <span>Ask Question</span>
            <h2>Frequently Asked Questions</h2>
            <!-- <p>Veniam quis nostrud exercitation ullamco laboris nist aute irure dolor in reprehenderit in voluptate velit esse nulla pariatur excepteur sint occaecat aboris nisi ut aliquip.</p> -->
        </div>

        <div class="row align-items-center">
            <div class="col-lg-6 col-md-12">
                <div class="faq-accordion">
                
                    <ul class="accordion">
                        <li class="accordion-item">
                            <a class="accordion-title">
                                <i class="fas fa-plus" (click)="toggleAccordion1($event)"></i>
                                What is vocbot?
                            </a>

                            <p class="accordion-content" [ngClass]="{'show': isAccordionOpen1}">VocBot is a AI-Based solution that uses voice interaction to replace manual customer care support with an automated process.</p>
                        </li>

                        <li class="accordion-item">
                            <a class="accordion-title">
                                <i class="fas fa-plus" (click)="toggleAccordion2($event)"></i>
                                How can I use Vocbot?
                            </a>

                            <p class="accordion-content" [ngClass]="{'show': isAccordionOpen2}">To access Vocbot, you must subscribe to Vocbot. Please reach out to the Vocbot sales team for a subscription.</p>
                        </li>

                        <li class="accordion-item">
                            <a class="accordion-title">
                                <i class="fas fa-plus" (click)="toggleAccordion3($event)"></i>
                                How can I Sign up on Vocbot?
                            </a>

                            <p class="accordion-content" [ngClass]="{'show': isAccordionOpen3}">For Sign-up, just click on the Log-in/Sign-up page and create your by choosing 'Create Account' option. From there, account has been created.</p>
                        </li>

                        <li class="accordion-item">
                            <a class="accordion-title">
                                <i class="fas fa-plus" (click)="toggleAccordion4($event)"></i>
                                In how many languages Vocbot works?
                            </a>

                            <p class="accordion-content" [ngClass]="{'show': isAccordionOpen4}">Vocbot having premium feature i.e. Multi-lingual languages which operates in both Hindi and English</p>
                        </li>

                        <li class="accordion-item">
                            <a class="accordion-title">
                                <i class="fas fa-plus" (click)="toggleAccordion5($event)"></i>
                                Can I use my voice in Vocbot?
                            </a>

                            <p class="accordion-content" [ngClass]="{'show': isAccordionOpen5}">Vocbot does not allow you to use your voice, but we have our own software for this purpose.</p>
                        </li>

                        <li class="accordion-item">
                            <a class="accordion-title">
                                <i class="fas fa-plus" (click)="toggleAccordion6($event)"></i>
                                What are the benefits of using Vocbot?
                            </a>

                            <p class="accordion-content" [ngClass]="{'show': isAccordionOpen6}">You will get features such as 24/7 call installation, Promotion Calls, Whatsapp Bulk Massaging that will help you increase customer satisfaction</p>
                        </li>

                        <li class="accordion-item">
                            <a class="accordion-title">
                                <i class="fas fa-plus" (click)="toggleAccordion7($event)"></i>
                                In how many domain Vocbot works?
                            </a>

                            <p class="accordion-content" [ngClass]="{'show': isAccordionOpen7}">Vocbot is not restricted to one industry, but it can operate in any industry, with a focus on Education, Healthcare, Retail, and Ecommerce.</p>
                        </li>

                        <li class="accordion-item">
                            <a class="accordion-title">
                                <i class="fas fa-plus" (click)="toggleAccordion8($event)"></i>
                                How can I Get demo of Vocbot?
                            </a>

                            <p class="accordion-content" [ngClass]="{'show': isAccordionOpen8}">Book a demo from the website at your convenience, and our team will give it to you based on your scheduled slot.</p>
                        </li>

                        <li class="accordion-item">
                            <a class="accordion-title">
                                <i class="fas fa-plus" (click)="toggleAccordion9($event)"></i>
                                How can I subscribe for Vocbot?
                            </a>

                            <p class="accordion-content" [ngClass]="{'show': isAccordionOpen9}">Get in touch with the Vocbot Sales team to obtain a subscription plan, and you will receive a subscription that matches your preference</p>
                        </li>
                    </ul>
                </div>
            </div>

            <div class="col-lg-6 col-md-12">
                <div class="faq-image">
                    <img src="assets/img/faq.png" alt="image">
                </div>
            </div>
        </div>

        <div class="faq-contact">
            <div class="section-title">
                <h2>Do You Have Any Questions</h2>
                <p>
                    Please read our privacy policy before submitting your contact information. 
                    By submitting this form you agree to have read the policy and receive our emails.
                    <!-- You will have the option to unsubscribe at any time. -->
                </p>
            </div>

            <div class="row align-items-center">
                <div class="col-lg-4 col-md-4">
                    <div class="faq-contact-image">
                        <img src="assets/img/contact.png" alt="image">
                    </div>
                </div>

                <div class="col-lg-8 col-md-8">
                    <div class="faq-contact-form">
                       
                            <form [formGroup]="contactForm" method="post">
                                <div class="row">
                                    <div class="col-lg-4 col-md-4 col-sm-12">
                                        <div class="form-group mb-3">
                                            <label class="formLabel">First Name:</label>
                                            <input type="text" placeholder="Name" class="form-control"
                                                formControlName="firstName" [ngClass]="{
                                          'input-Error':
                                            contactForm.get('firstName').touched &&
                                            contactForm.get('firstName').dirty &&
                                            contactForm.get('firstName').invalid
                                        }" />
        
                                            <label class="formError" *ngIf="
                                        contactForm.get('firstName').touched &&
                                        contactForm.get('firstName').hasError('required') &&
                                        contactForm.get('firstName').invalid
                                      ">First Name is required!</label>
                                        </div>
                                    </div>
        
                                    <div class="col-lg-4 col-md-4 col-sm-12">
                                        <div class="form-group mb-3">
                                            <label class="formLabel">Last Name:</label>
                                            <input type="text" placeholder="Surname" formControlName="lastName"
                                                class="form-control" [ngClass]="{
                                          'input-Error':
                                            contactForm.get('lastName').touched &&
                                            contactForm.get('lastName').dirty &&
                                            contactForm.get('lastName').invalid
                                        }" />
        
                                            <label class="formError" *ngIf="
                                          contactForm.get('lastName').touched &&
                                          contactForm.get('lastName').hasError('required') &&
                                          contactForm.get('lastName').invalid
                                        ">Last Name is required!</label>
                                        </div>
                                    </div>
        
                                    <div class="col-lg-4 col-md-4 col-sm-12">
                                        <div class="form-group mb-3">
                                            <label class="formLabel">Subject:</label>
                                            <input type="text" placeholder="Position" formControlName="position"
                                                class="form-control" [ngClass]="{
                                          'input-Error':
                                            contactForm.get('position').touched &&
                                            contactForm.get('position').dirty &&
                                            contactForm.get('position').invalid
                                        }" />
        
                                            <label class="formError" *ngIf="
                                        contactForm.get('position').touched &&
                                        contactForm.get('position').hasError('required') &&
                                        contactForm.get('position').invalid
                                      ">Subject is required!</label>
                                        </div>
                                    </div>
        
                                    <div class="col-lg-4 col-md-4 col-sm-12 form-group mb-3">
                                        <label class="formLabel">Email:</label>
                                        <input
                                          type="email"
                                          placeholder="name@example.com"
                                          formControlName="email"
                                          class="form-control"
                                          [ngClass]="{
                                            'input-Error': contactForm.get('email').touched && contactForm.get('email').dirty && contactForm.get('email').invalid
                                          }"
                                        />
                                        <label class="formError" *ngIf="
                                          contactForm.get('email').touched &&
                                          contactForm.get('email').hasError('required') &&
                                          contactForm.get('email').invalid
                                        ">
                                          Email is required!
                                        </label>
                                        <!-- <label class="formError" *ngIf="
                                          contactForm.get('email').touched &&
                                          contactForm.get('email').hasError('email') &&
                                          contactForm.get('email').invalid
                                        ">
                                          Invalid email format!
                                        </label> -->
                                        <label class="formError" *ngIf="
                                          contactForm.get('email').touched &&
                                          contactForm.get('email').hasError('uppercaseEmail') &&
                                          contactForm.get('email').invalid
                                        ">
                                        Invalid email format!
                                        </label>
                                        <label class="formError" *ngIf="
                                          contactForm.get('email').touched &&
                                          contactForm.get('email').hasError('customEmailInvalid') &&
                                          contactForm.get('email').invalid
                                        ">
                                        Invalid email format!
                                        </label>
                                      </div>
                                      
                                      <div class="col-lg-4 col-md-4 col-sm-12">
                                        <div class="form-group mb-3">
                                          <label class="formLabel">Phone Number:</label>
                                          <input
                                            type="text"
                                            placeholder="+91 XXXXXXXXXX"
                                            formControlName="contactNumber"
                                            class="form-control"
                                            maxlength="10"
                                            (input)="onInputChange($event)"
                                          />
                                          <label class="formError" *ngIf="
                                            contactForm.get('contactNumber').touched &&
                                            contactForm.get('contactNumber').hasError('required') &&
                                            contactForm.get('contactNumber').invalid
                                          ">
                                            Phone Number is required!
                                          </label>
                                          <label class="formError" *ngIf="
                                            contactForm.get('contactNumber').touched &&
                                            contactForm.get('contactNumber').hasError('minlength') &&
                                            contactForm.get('contactNumber').invalid
                                          ">
                                            Contact number must be 10 digits.
                                          </label>
                                          <label class="formError" *ngIf="
                                            contactForm.get('contactNumber').touched &&
                                            contactForm.get('contactNumber').hasError('maxlength') &&
                                            contactForm.get('contactNumber').invalid
                                          ">
                                            Contact number must be 10 digits.
                                          </label>
                                          <label class="formError" *ngIf="
                                            contactForm.get('contactNumber').touched &&
                                            contactForm.get('contactNumber').hasError('pattern') &&
                                            contactForm.get('contactNumber').invalid
                                          ">
                                            Contact number must contain only digits.
                                          </label>
                                        </div>
                                      </div>
                                      
        
                                    <div class="col-lg-4 col-md-4 col-sm-12 form-group mb-3">
                                        <label class="formLabel">Location:</label>
                                        <input type="text" placeholder="Location" formControlName="location"
                                            class="form-control" [ngClass]="{
                                        'input-Error':
                                          contactForm.get('location').touched &&
                                          contactForm.get('location').dirty &&
                                          contactForm.get('location').invalid
                                      }" />
                                        <label class="formError" *ngIf="
                                        contactForm.get('location').touched &&
                                        contactForm.get('location').hasError('required') &&
                                        contactForm.get('location').invalid
                                      ">Location is required!</label>
                                    </div>
                                </div>
        
        
                                <div class="row">
        
        
                                    <div class="col-lg-12 col-md-12 col-sm-12 form-group mb-3">
                                        <label class="formLabel">Additional information:</label>
                                        <textarea placeholder="What are you interested in?" formControlName="detail"
                                            class="form-control" cols="30" rows="5" [ngClass]="{
                                          'input-Error':
                                            contactForm.get('detail').touched &&
                                            contactForm.get('detail').dirty &&
                                            contactForm.get('detail').invalid
                                        }"></textarea>
                                        <label class="formError" *ngIf="
                                          contactForm.get('detail').touched &&
                                          contactForm.get('detail').dirty &&
                                          contactForm.get('detail').invalid
                                        ">Description is required!</label>
                                    </div>
                                </div>
                                <div class="col-lg-12 col-md-12 col-sm-12 form-Group">
                                  <re-captcha #captchaRef="reCaptcha" (resolved)="resolved($event)" required
                                      (error)="onError($event)" (expired)="onCaptchaExpired()" [siteKey]="siteKey" errorMode="handled"
                                      (focusout)="captchaRef.execute()" >
                                      <!-- size="invisible" -->
                                  </re-captcha>
                              </div>
        
                                <div class="row" style="padding-top: 25px;">
        
                                    <div class="col-lg-12 col-md-12 col-sm-12">
                                        <button type="submit" class="btns btn-primarys" (click)="sendMail()">
                                            Send Message
                                        </button>
                                        <div id="msgSubmit" class="h3 text-center hidden"></div>
                                        <div class="clearfix"></div>
                                    </div>
                                </div>
                            </form>
        
                       
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>




<!-- End FAQ Area -->


<!-- <div class="accordion" id="accordionExample">
    <div class="card">
      <div class="card-header" id="headingOne">
        <h2 class="mb-0">
          <button class="btn btn-link" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
            Collapsible Group Item #1
          </button>
        </h2>
      </div>
  
      <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample">
        <div class="card-body">
          Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable VHS.
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card-header" id="headingTwo">
        <h2 class="mb-0">
          <button class="btn btn-link collapsed" type="button" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
            Collapsible Group Item #2
          </button>
        </h2>
      </div>
      <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#accordionExample">
        <div class="card-body">
          Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable VHS.
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card-header" id="headingThree">
        <h2 class="mb-0">
          <button class="btn btn-link collapsed" type="button" data-toggle="collapse" data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
            Collapsible Group Item #3
          </button>
        </h2>
      </div>
      <div id="collapseThree" class="collapse" aria-labelledby="headingThree" data-parent="#accordionExample">
        <div class="card-body">
          Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable VHS.
        </div>
      </div>
    </div>
  </div> -->